import styled from "styled-components";
import SearchIcon from "@material-ui/icons/Search";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 100%;
`;

export const InputText = styled.input`
  width: 50%;
  color: #757575;
  margin-right: 10px;
  border: 1px;
  border-color: #757575;
  border-style: solid;
  @media (max-width: 768px) {
    width: 80%;
  }
`;

export const ImgLupa = styled(SearchIcon)`
  color: #757575;
  &:hover{
    transition: 1s;
    opacity: 0.5 ;
    cursor: pointer;
    font-size:50px;
  }
`;

export const SelectEspcialidade = styled.select`
  margin-right: 10px;
`;
